import { render, staticRenderFns } from "./MainMediaWindowEmptyState.vue?vue&type=template&id=72d6e526&"
import script from "./MainMediaWindowEmptyState.vue?vue&type=script&lang=js&"
export * from "./MainMediaWindowEmptyState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports